
import { defineComponent, reactive, ref, watch } from "vue";
import {
  AdminTableLayout,
  ReportTable,
} from "@/components/Common";

import { useRoute, useRouter } from "vue-router";
import {
  useDynamicDialog,
  usePagination,
  useReportTableShowColumn,
} from "@/hooks";

import { tableColumn } from "./addressBookTableColumn";

import {
  DeleteAddressCmd,
  EditAddress,
  GetAddresses,
} from "@/api-server/modules/defaultServer";
import { formatThisMonth } from "@/utils/formatter";
import { useStore } from "vuex"
import { RootState } from "@/@types/store";
import { ElMessage, ElMessageBox, ElTable } from "element-plus";

export default defineComponent({
  name: "AfterSalesWorkOrder",
  components: {
    AdminTableLayout,
    ReportTable,
  },

  props: {
    isDialog: {
      type: Boolean,
      default: false
    },
    multiSelect: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 0
    },
  },

  emits: ["select"],

  setup(props, { emit }) {
    const store = useStore<RootState>();
    const { getModelUUID, openModel } = useDynamicDialog();
    const formData = ref({
      type: 0
    })

    const multipleTableRef = ref<any>()

    const selectData = ref([])

    const tabs = ref([
      {
        label: "发货地址",
        value: 0,
      },
      {
        label: "客户地址",
        value: 1,
      },
    ]);

    const { showTableColumn } = useReportTableShowColumn(tableColumn(props, selectData));

    const {
      loading,
      pageNum,
      pageSize,
      pageSizeList,
      totalNum,
      tableData,
      currentPageChangeHandle,
      sizeChangeHandle,
      onSearchHandle,
      requestTableData,
      errorCode,
    } = usePagination(GetAddresses.fetch, formData,
      (editFormData) => {
        return {
          ...editFormData.value
        };
      },
    );

    const handleDelete = async (row: any) => {
      await  ElMessageBox.confirm("请确认是否要删除该地址？", "警告", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
      const { type, id } = row
      await DeleteAddressCmd.fetch({ ids: [id], type })
      ElMessage.success({ showClose: true, message: "删除成功" });
      requestTableData() 
    }

    const handleDefault = async (row: any) => {
      loading.value = true
      EditAddress.fetch({ ...row, defaultAddress: 0 }).finally(() => {
        loading.value = false
        requestTableData()
      })
    }

    async function handleEdit(data: any) {
      const uuid = await getModelUUID("admin/address-manage/address-book/editDialog");
      openModel(
        uuid,
        {
          formType: data ? 'edit': 'add',
          formData: { ...data, ...formData.value  },
        },
        {
          updateSuccess: requestTableData,
        }
      );
    }

    const handleSelect = (selection: any) => {
      if (!props.multiSelect && selection.length > 1) {
        const selelct = selection.slice(0, 1)
        multipleTableRef.value?.toggleSelection()
        multipleTableRef.value?.toggleSelection(selelct, true)
        selectData.value = selelct
      } else {
        selectData.value = selection
      }
      emit('select', props.multiSelect ? selectData.value : selectData.value[0])
    }

    watch(() => props.type, (type) => {
      formData.value.type = type
    }, {
      immediate: true
    })

    watch(() => formData.value.type, () => {
      onSearchHandle()
    })

    return {
      formData,
      loading,
      pageNum,
      pageSize,
      pageSizeList,
      totalNum,
      currentPageChangeHandle,
      sizeChangeHandle,
      onSearchHandle,
      requestTableData,
      showTableColumn,
      tableData,
      formatThisMonth,
      errorCode,
      handleDelete,
      handleEdit,
      handleDefault,
      store,
      handleSelect,
      multipleTableRef,
      tabs,
    };
  },
});
